<div class="d-flex flex-column mh-100vh scroll-over-topbar" *ngIf="job">

  <app-topbar (optOutClick)="optOutClick()"></app-topbar>

  <sc-json-ld [json]="job?.JsonLd"></sc-json-ld>

  <div>
    <app-header [job]="job"></app-header>
  </div>

  <app-navbar [job]="job" (activeItemChanged)="scrollToSection($event);"></app-navbar>

  <div>

    <section id="aufgaben">

      <div class="container">

        <div class="row">

          <div class="col-12 col-lg-10 offset-lg-1">

            <h2 class="mb-5 mb-lg-6">
              <span>{{ 'Ihre Aufgaben' | localize }}</span>
            </h2>

            <div class="row">

              <div class="col-12 order-1 col-md-12 col-lg-4">
                <app-collapsible-list [listItems]="job?.Tags" [listTopItems]="job?.TopTags"></app-collapsible-list>
              </div>

              <div class="col-12 order-2 col-md-12 col-lg-7 offset-lg-1">
                <p style="white-space: pre-wrap;" [innerHtml]="job?.Description | bypassSecurityTrust : 'html'"></p>
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

    <section id="project-video" *ngIf="job.VideoUri != null">

      <div class="container">

        <div class="mt-4 mt-lg-0">
          <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <app-video video-uri="{{ job.VideoUri }}"></app-video>
            </div>
          </div>
        </div>

      </div>

    </section>

    <section id="projects" *ngIf="job?.ProjectExamples?.length > 0 && !job.VideoUri">

      <div class="container">

        <div class="row">

          <div class="col-12 col-lg-10 offset-lg-1 blob">

            <img src="assets/blobs/blob-4.svg" />

            <div [class.slider]="job?.ProjectExamples?.length > 1" class="mt-4 mt-lg-0">

              <div *ngIf="job?.ProjectExamples?.length == 1 && isBrowser">

                <div class="row align-items-md-center">

                  <div class="col-12 col-md-5 col-lg-4">
                    <h6 class="header-pretitle">{{ 'Projektbeispiel' | localize }}</h6>
                    <h2>{{job.ProjectExamples[0].Title}}</h2>
                    <p [innerHTML]="job.ProjectExamples[0].Description"></p>
                  </div>

                  <div class="col-12 mt-3 mt-md-0 col-md-7 offset-md-0 col-lg-7 offset-lg-1">
                    <img src="{{ job.ProjectExamples[0].Image }}" class="img-fluid" />
                  </div>

                </div>

              </div>

              <div *ngIf="job?.ProjectExamples?.length > 1 && isBrowser">
                <app-slider *ngIf="job.Id != 2226 && job.Id != 2365" [slides]="job?.ProjectExamples" [isProjectSlider]="true"></app-slider>
                <app-slider *ngIf="job.Id == 2226 || job.Id == 2365" [slides]="job?.ProjectExamples" [isProjectSlider]="true" headline="Rolle"></app-slider>
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

    <section id="gehalt-und-benefits">

      <div id="gehalt">

        <div class="container">

          <div class="row">

            <div class="col-12 col-lg-10 offset-lg-1">

              <div class="row align-items-md-center">

                <div class="col-12 col-md-5 mb-md-6">

                  <h2>
                    <span *ngIf="job?.EmploymentType != 'Freelancer'">{{ 'Ihr Gehalt' | localize }}</span>
                    <span *ngIf="job?.EmploymentType == 'Freelancer'">{{ 'Ihr Honorar' | localize }}</span>
                  </h2>

                  <p *ngIf="!isSkillconomy() && job?.EmploymentType != 'Freelancer'">
                    {{'Mithilfe unserer umfassenden Jobdatenbank schätzen wir für Sie ab, in welchem Bereich Ihr zukünftiges Zielgehalt liegen wird.' | localize }}
                  </p>

                  <p *ngIf="!isSkillconomy() && job?.EmploymentType == 'Freelancer'">
                    {{'Mithilfe unserer umfassenden Jobdatenbank schätzen wir für Sie ab, in welchem Bereich Ihr zukünftiges Honorar liegen wird.' | localize }}
                  </p>

                  <p *ngIf="isSkillconomy()">
                    {{ 'Hier siehst du vorab die grobe Gehaltsrange der Position. Lass uns gerne im persönlichen Gespräch über das zu dir passende Gesamtpaket sprechen.' | localize }}
                  </p>

                </div>

                <div class="col-12 col-md-6 offset-md-1">
                  <app-salarygraph 
                    *ngIf="job?.Language != 'en'" 
                    minValue="{{job?.Compensation.MinSalary | number:'1.0-0':'de' }} {{ job?.Compensation.SalaryCurrency }}" 
                    maxValue="{{job?.Compensation.MaxSalary | number:'1.0-0':'de'}} {{ job?.Compensation.SalaryCurrency }}">
                  </app-salarygraph>

                  <app-salarygraph 
                    *ngIf="job?.Language == 'en'" 
                    minValue="{{job?.Compensation.MinSalary | number:'1.0-0':'en' }} {{ job?.Compensation.SalaryCurrency }}" 
                    maxValue="{{job?.Compensation.MaxSalary | number:'1.0-0':'en' }} {{ job?.Compensation.SalaryCurrency }}">
                  </app-salarygraph>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <div id="benefits">

        <div class="container">

          <div class="row">

            <div class="col-12 col-lg-10 offset-lg-1">

              <h2 class="mt-6 mt-md-4">
                <span>{{ 'Ihre Benefits' | localize }}</span>
              </h2>

              <ul class="list-group-flush list-group list-type-icon d-md-icon-grid mt-5" *ngIf="job">
                <li *ngFor="let benefitId of job?.BenefitIds" class="list-group-item">
                  <app-benefit [id]="benefitId" [language]="language"></app-benefit>
                </li>
              </ul>

            </div>

          </div>

        </div>

      </div>

    </section>

    <section id="arbeitsumfeld">

      <div class="container">

        <div class="row">

          <div class="col-12 col-lg-10 offset-lg-1">

            <h2 class="mb-5 mb-lg-6">
              <span>{{ 'Ihr Arbeitsumfeld' | localize }}</span>
            </h2>

            <div class="row">

              <div class="col-12 col-lg-4">

                <h6 class="mb-4 mb-lg-4">
                  <span>{{ 'Ihre Vorteile' | localize }}</span>
                </h6>

                <ul class="list-group-flush list-group list-type-icon d-md-grid">
                  <li *ngFor="let benefit of job?.Highlights" class="list-group-item">
                    <span class="fa-icon">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    <span>{{benefit}}</span>
                  </li>
                </ul>

              </div>

              <div class="col-12 col-lg-7 offset-lg-1">

                <div class="slider mt-4 mt-lg-0">
                  
                  <div *ngIf="job?.Impressions?.length > 0 && isBrowser">
                    <sc-slider #workplaceSlider>
                      <div *ngFor="let item of job.Impressions">
                        <li class="slide">
                          <figure>
                            <picture>
                                <img [src]="item.ImageUri" height="800" width="800" class="img-fluid">
                            </picture>
                            <figcaption class="is-muted mt-3"><strong *ngIf="item.Title != ''" class="me-2">{{item.Title}}</strong>
                              <span [innerHTML]="item.Description"></span>
                            </figcaption>
                          </figure>
                        </li>
                      </div>
                    </sc-slider>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <app-map *ngIf="isBrowser && !job.IsMapHidden" id="standorte" [job]="job"></app-map>

    </section>

    <section id="unternehmen">

      <div class="container">

        <div class="row">

          <div class="col-12 col-lg-10 offset-lg-1 mb-5">

            <h2 class="mb-5 mb-lg-6">{{ 'Unternehmen' | localize }}</h2>

            <div class="row">

              <div class="col-12 col-lg-4 mb-6">

                <h6 class="mb-5">
                  <span>{{ 'Ihre Vorteile' | localize }}</span>
                </h6>

                <ul class="list-group-flush list-group list-type-icon d-md-grid">
                  <li *ngFor="let highlight of job.Company.Highlights" class="list-group-item">
                    <span class="fa-icon">
                      <i class="fa-sharp fa-solid fa-check"></i>
                    </span>
                    <span>{{highlight}}</span>
                  </li>
                </ul>

              </div>

              <div class="col-12 col-lg-7 offset-lg-1">

                <h6 class="mb-5">{{ job?.Company.Name }}</h6>

                <div *ngIf="job.Company.VideoUri != null" class="mb-5">
                  <app-video video-uri="{{ job.Company.VideoUri }}"></app-video>
                </div>
              
                <p style="white-space: pre-wrap;" [innerHtml]="job?.Company.Description | bypassSecurityTrust : 'html'"></p>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

    <section class="sc-cta mb-8">
      <div class="container">
        <div class="row d-flex align-items-center justify-content-center">
          <div class="d-flex flex-column">
            <button class="btn btn-lg btn-round btn-primary" (click)="showInitialChatbot()">
              <i class="fa-sharp fa-solid fa-circle-chevron-right me-2"></i>
              {{ 'Ist das Angebot interessant?' | localize }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <sc-chatbot-overlay *ngIf="isBrowser" #chatbotOverlay [chat]="chat" [requestShow]="showChat" (chatEnded)="handleEndOfChat($event)"></sc-chatbot-overlay>

  </div>

  <app-footer class="mt-auto"></app-footer>
</div>